module.exports = __webpack_public_path__ + "static/media/azure.065ccd68.png";